define( 'editor/js/user_monitoring',[ 'jclass' ], function( Class ) {
	'use strict';

	/*
	===============================================================================
	Class: User Monitoring
	===============================================================================
	*/

	var UserMonitoring = Class._extend( {

		/**
		* Method: send
		* @param {String} action
		* @param {Object} options
		*/

		send: function( action, options ) {
			try {
				DD_RUM.addAction( action, options ); // eslint-disable-line no-undef
			}
			catch( err ) {
				console.warn( "Datadog RUM is deactivated in development. If you want to activate it, change visibility in index.html" ); // eslint-disable-line no-console
			}
		},

		/**
		* Method: send
		* @param {String} event
		* @param {Object} options
		*/

		action: function( eventName, options ) {
			return this.send( eventName, options );
		},

		/**
		* Method: send
		* @param {String} event
		* @param {Object} options
		*/

		image: function( event, options ) {
			var sanitizedOptions = options || { };

			if ( options.destination !== undefined && options.destination.content !== undefined ) {
				delete sanitizedOptions.destination.content;
			}
			return this.send( event, sanitizedOptions );
		}

	} );

	return UserMonitoring;
} );

